/**
 * Die Rückfrage „Bisch sicher?" (FR-CONF-01 bis FR-CONF-05).
 *
 * Sie erscheint einmal je Markierung und nacheinander, wenn mehrere
 * anstehen. Nicht wegklickbar nebenbei: hier soll jemand entscheiden, nicht
 * ausweichen. Die Tonlage kommt vom Event.
 */
import { useLang } from '../lang'
import { ASK_BODY, type Tone } from '../lib/i18n'
import type { Question, Term } from '../lib/types'
import { Sheet } from './Sheet'

export function AskSheet({
  question,
  term,
  others,
  tone,
  onAnswer,
}: {
  question: Question
  term?: Term
  others: number
  tone: Tone
  onAnswer: (markId: string, keep: boolean) => void
}) {
  const { t, pickText, lang } = useLang()
  const label = pickText(term?.text) || question.termId

  return (
    <Sheet title={t('ask.title')} dismissible={false} onClose={() => onAnswer(question.markId, true)}>
      <p style={{ fontSize: 17, marginTop: 0 }}>{ASK_BODY[lang][tone](label, others)}</p>
      <div className="row" style={{ marginTop: 16 }}>
        <button type="button" className="btn btn--block" onClick={() => onAnswer(question.markId, true)}>
          {t('ask.keep')}
        </button>
        <button
          type="button"
          className="btn btn--ghost btn--block"
          onClick={() => onAnswer(question.markId, false)}
        >
          {t('ask.drop')}
        </button>
      </div>
    </Sheet>
  )
}
